module.exports = __webpack_public_path__ + "h5/img/vs1.d12cf01a.png";